import { render } from "./LocationCardComponent.vue?vue&type=template&id=0fa9bcd5"
import script from "./LocationCardComponent.vue?vue&type=script&lang=js"
export * from "./LocationCardComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Projects\\anygence\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__